export default {
      id: "i-news-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/sprite.svg#i-news",
      toString: function () {
        return this.url;
      }
    }